import React from 'react';
import Image from "next/image";
import Link from "next/link";
import {CategoryCardProps} from "@/interface/components/category/category-card";
import NoImage from "@/public/no-image.jpg";

const CategoryCard = ({image, title, slug}: CategoryCardProps) => {
    return (
        <Link href={`/category/${slug}`}
              className={"bg-neutral-50 mx-auto rounded-2xl flex flex-wrap content-center justify-center gap-4 py-3 md:w-[200px] md:h-[200px] overflow-hidden transition-all w-[130px] h-[130px]  hover:shadow mb-4"}>
            <Image src={image ?? NoImage} alt={`image-${title}`} title={`image-${title}`} width={130} height={130}
                   className={"md:w-[130px] md:h-[130px] w-[86px] rounded-xl h-[86px]"}/>
            <h3 className={"w-full  text-center text-global-text-color text-xs md:text-sm font-bold  line-clamp-1 px-2"}>{title}</h3>
        </Link>
    );
};

export default CategoryCard;